module.exports = __webpack_public_path__ + "static/img/6.10a7ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-es/6.jpg
// module id = FwPy
// module chunks = 1